import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);        
        const currentTime = Date.now() / 1000;
        return decoded.exp < currentTime;
    } catch (error) {
        return true;
    }
}

export const checkToken = () => {
    const profile = localStorage.getItem('profile');
    const usersData = JSON.parse(profile);
    
    if (usersData != null && usersData.data.token && isTokenExpired(usersData.data.token)) {
        localStorage.removeItem('store');
        localStorage.removeItem('profile');
        window.location.href = '/login';
    }
}
